import React from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import { getTranslatedMsg } from "../../utils/favoriteMCTranslatedmsg";
import { connect } from "react-redux";
import MomentLocaleUtils from 'react-day-picker/moment';
import 'moment/locale/ja';
import 'moment/locale/ar';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/pt';
import 'moment/locale/da';
import 'moment/locale/ru';
import 'moment/locale/de';
import 'moment/locale/fi';
import 'moment/locale/es';
import 'moment/locale/nl';
import 'moment/locale/sv';
import 'moment/locale/zh-cn';
import 'moment/locale/hu';
import { ModifiersUtils } from "react-day-picker";
/* import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse'; */
let checkInDate = undefined;
let checkOutDate = undefined;
let lastCheckoutDate = undefined;
//let checkInDateGreater =false
function Navbar({
  month,
  onPreviousClick,
  onNextClick,
  showNextButton,
  showPreviousButton
}) {
  let availibilityMonth = month.toString();
  //debugger;
  let getMonth = availibilityMonth.split(" ");
  let monthDisplaying = getMonth[1];
  //console.log(monthDisplaying);
  const styleLeft = { float: 'left' };
  const styleRight = { float: 'right' };
  
  return (
    <div className=" cal-nav-btn-container">
      <button data-id={monthDisplaying} id="prev-month" type="button" style={styleLeft} onClick={() => onPreviousClick()} className={`cal-nav-btn-zindex  cal-arrow-btn btn btn-ghost`} disabled={!showPreviousButton}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="svg-fill-gray"><polygon fill="#FFF" fillRule="evenodd" points="16 7.41 14.478 6 8 12 14.478 18 16 16.59 11.055 12"></polygon></svg></button>
      <button data-id={monthDisplaying} id="next-month" type="button" style={styleRight} onClick={() => onNextClick()} className={`cal-nav-btn-zindex cal-arrow-btn btn btn-ghost`} disabled={!showNextButton}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="svg-fill-gray"><polygon fill="#FFF" fillRule="evenodd" points="8 16.59 12.945 12 8 7.41 9.522 6 16 12 9.522 18"></polygon></svg></button>
    </div>
  );
}
function NavbarMobile({onPreviousClick,
  onNextClick,
  showNextButton,
  showPreviousButton}) {
    const styleLeft = { float: 'left' };
    const styleRight = { float: 'right' };
  return (
    <div className=" cal-nav-btn-container">
      <button  id="prev-month" onClick={() => onPreviousClick()} type="button" style={styleLeft} className={`cal-nav-btn-zindex  cal-arrow-btn btn btn-ghost`} disabled={!showPreviousButton}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="svg-fill-gray"><polygon fill="#FFF" fillRule="evenodd" points="16 7.41 14.478 6 8 12 14.478 18 16 16.59 11.055 12"></polygon></svg></button>
      <button id="next-month" type="button" style={styleRight} onClick={() => onNextClick()} className={`   cal-nav-btn-zindex cal-arrow-btn btn btn-ghost`} disabled={!showNextButton}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="svg-fill-gray"><polygon fill="#FFF" fillRule="evenodd" points="8 16.59 12.945 12 8 7.41 9.522 6 16 12 9.522 18"></polygon></svg></button>
    </div>
  );
}

function Weekday({ weekday, className, localeUtils, locale }) {
  const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return (
    <div className={className} title={weekdayName}>
      {weekdayName.slice(0, 3)}
    </div>
  );
}


class RCIDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);

    this.state = this.getInitialState();

  }
  getInitialState() {
    return {
      from: undefined,
      to: undefined,
      calFromDisplay: true,
      calToDisplay: false,
      local: this.props.DatePickerLocal,
      monthsToShow: 1,
      isMobileDevice: this.props.deviceType,
      msg_data: this.props.msg_data,
      custlocale: this.props.custlocale,
      selectedDay: undefined


    }
  }
  resetInitialState() {
    return {
      from: undefined,
      to: undefined,
      calFromDisplay: true,
      calToDisplay: false,
      local: this.props.DatePickerLocal,
      isMobileDevice: this.props.deviceType,
      msg_data: this.props.msg_data,
      custlocale: this.props.custlocale,
      selectedDay: undefined

    }
  }
  handleDayClick(day, modifiers = {}, event) {
    //debugger;
    let calenderElement = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.id;
    //console.log(event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.id)
    if (modifiers.disabled) {
      return;
    } else {
      if (this.props.monthsToDisplay > 1) {
        if (this.props.$highlightBothSelectedDays) {
          if (this.state.from && this.state.to) {
            this.setState(this.resetInitialState(), () => {
              const range = DateUtils.addDayToRange(day, this.state);
              this.props.calDayBtnClickFn(range.from, range.to, modifiers);
              this.setState(range);
              if (checkInDate === undefined) {
                if(this.props.$containerId === "checkIndatePickerContainer"){
                  checkInDate = range.from
                }
                else{
                  checkOutDate = range.from
                }
                
              }
              else {
                if (lastCheckoutDate !== range.from || checkOutDate === undefined) {
                  checkOutDate = range.from;
                  lastCheckoutDate = range.from
                }
                else {
                  checkOutDate = range.to;
                  lastCheckoutDate = range.to;
                }
              }
            });
          } else {
            const range = DateUtils.addDayToRange(day, this.state);
            this.props.calDayBtnClickFn(range.from, range.to, modifiers);
            this.setState(range);
            if (checkInDate === undefined) {
              checkInDate = range.from
            }
            else {
              if (lastCheckoutDate !== range.from || checkOutDate === undefined) {
                checkOutDate = day;
                
                lastCheckoutDate = day;
              }
              else {
                checkOutDate = range.to;
                lastCheckoutDate = range.to;
              }


            }
          }
        }
        else {
          this.setState(this.resetInitialState(), () => {
            const range = DateUtils.addDayToRange(day, this.state);
            this.props.calDayBtnClickFn(range.from, range.to, modifiers);
            this.setState(range);
            // checkInDate === undefined ? checkInDate=range.from : checkOutDate =range.from;
            if (checkInDate === undefined) {
              checkInDate = range.from
            }
            else {
              if (lastCheckoutDate !== checkOutDate || checkOutDate === undefined) {
                checkOutDate = range.from;
                lastCheckoutDate = range.from
              }
              else {
                checkInDate = range.from;
              }


            }
          });
        }

      } else if (this.props.monthsToDisplay == 1) {
        this.setState(this.resetInitialState(), () => {
          const range = DateUtils.addDayToRange(day, this.state);
          this.props.calDayBtnClickFn(range.from, range.to, modifiers);
          this.setState(range);
          if (checkInDate === undefined) {
            checkInDate = range.from
          }
          else {
            if (lastCheckoutDate !== checkOutDate || checkOutDate === undefined) {
              checkOutDate = range.from;
              lastCheckoutDate = range.from
            }


          }
        });
      }
    }
  }
  applyBtnClick = () => {
    this.props.applyBtnClickFn(this.state.from, this.state.to);
  }
  handleResetClick = () => {
    this.setState(this.resetInitialState());
    this.props.resetCalfeilds();
    checkInDate = undefined;
    checkOutDate = undefined;
    lastCheckoutDate = undefined;
  }
  hideDatePicker = () => {
    this.props.toggleDatePickerhide()
  }
/*   componentDidMount() {
    console.log(this.state.isMobileDevice );
    if (this.state.isMobileDevice === 'sm') {
      if (this.props.monthsToDisplay === 1 || this.props.monthsToDisplay === 2) {
        this.setState({ monthsToShow: 1 });
      }
      else {
        this.setState({ monthsToShow: 24 });
      }
    } else {
      this.setState({ monthsToShow: this.props.monthsToDisplay });
    }
  } */

  /* componentDidUpdate(previousProps, previousState){
    //debugger;
    if (previousProps.deselectChekInDate !== this.props.deselectChekInDate) {
      console.log(this.props.prevSelectedChekInDate);
    this.setState({from:undefined})
  }
  else if(previousProps.deselectChekOutDate !== this.props.deselectChekOutDate){
    this.setState({...this.state, to:undefined})
  } 
   
  } */
  parseDate(str, format, locale) {
    debugger
    //const parsed = dateFnsParse(str, format, new Date(), { locale });
    const parsed = new Date();
    if (DateUtils.isDate(new Date())) {
      return parsed;
    }
    return undefined;
  }



  render() {
    //let deviceConfig = ScreenType();

    let monthToDisplay = 1
     if (!this.props.$ipadLandscape) {
      if (this.props.monthsToDisplay === 1 || this.props.monthsToDisplay === 2) {
        //this.setState({ monthsToShow: 1 });
        monthToDisplay = 1
      }
      else {
        //this.setState({ monthsToShow: 24 });
        monthToDisplay = 24
      }
    } 
    else {
      //this.setState({ monthsToShow: this.props.monthsToDisplay });
      monthToDisplay = this.props.monthsToDisplay
    }
    //debugger;
    const { from, to, selectedDay } = this.state;
    const modifiers = { start: from, end: to, highlighted: this.props.$showSelctedCheckinDays };

    const selctedDayStyle = `.DayPicker-Day--highlighted {
      background-color: #037092;
      color: white;
    }
    .DayPicker-Day--to, .DayPicker-Day--from {
      background-color: #037092;
      color: white;
    }`;

    let range, selected = {}
    let disableDaysTimeFrame = [
      {
        after: this.props.toMonth,
        before: this.props.fromMonth,
      }
    ]

    if (this.props.$containerId === "checkOutdatePickerContainer") {
      /* let selectedCheckInDate = checkInDate;
      selectedCheckInDate=selectedCheckInDate.setDate(selectedCheckInDate.getDate() + 1) */
      if (this.props.deselectChekOutDate) {
        //debugger;
        range = {
          from: checkInDate,
          to: undefined,
        }
        selected = {
          from: checkInDate,
          to: undefined,
          /*  from: new Date(checkInDate), 
           to: new Date(checkOutDate),  */
        }
      }
      disableDaysTimeFrame = [
        {
          before: this.props.$showSelctedCheckinDays,
          after: this.props.toMonth,
          
        }
      ]
      if(this.props.checkOutContainerClick){
        range = {
          from: undefined,
          to: checkOutDate === undefined ? checkInDate : checkOutDate,
        }
        selected = {
          from: undefined,
          to: checkOutDate === undefined ? checkInDate : checkOutDate,
          /*  from: new Date(checkInDate), 
           to: new Date(checkOutDate),  */
        }
      }
      else{
       /*  checkInDate < checkOutDate{
          
        } */
        if (checkInDate > checkOutDate) {
          checkOutDate = undefined;
          //checkInDateGreater = true;
        };
        range = {
          from: checkInDate,
          to: checkOutDate,
        }
        selected = {
          from: checkInDate,
          to: checkOutDate,
          /*  from: new Date(checkInDate), 
           to: new Date(checkOutDate),  */
        }
      }
     
    }
    else if (this.props.$containerId === "checkIndatePickerContainer") {
      /*  selected = {
         from: checkInDate,
         to: this.props.toMonth
       } */
     /*  if (checkInDate > checkOutDate) {
        checkOutDate = undefined;
        //checkInDateGreater = true;
      }; */
      if(this.props.checkInContainerClick){
        range = {
          from: undefined,
          to: undefined,
        }
      }
      else{
        range = {
          from: checkInDate,
          to: undefined,
        }
      }
      selected = {
        from: undefined,
        to: undefined,
        /*  from: new Date(checkInDate), 
         to: new Date(checkOutDate),  */
      }
      disableDaysTimeFrame = [
        {
          after: this.props.toMonth,
          before: this.props.fromMonth,
        }
      ]
      //checkOutDate = undefined;
    }
    if (this.props.deselectChekOutDate) {
      //debugger;
      range = {
        from: checkInDate,
        to: undefined,
      }
      selected = {
        from: checkInDate,
        to: undefined,
        /*  from: new Date(checkInDate), 
         to: new Date(checkOutDate),  */
      }
    }
    if (this.props.deselectChekInDate) {
      selected = {
        from: undefined,
        to: undefined,
        /*  from: new Date(checkInDate), 
         to: new Date(checkOutDate),  */
      }
      checkInDate = undefined;
    }
    let SearchstartDate = new Date();
    SearchstartDate = SearchstartDate.setDate(SearchstartDate.getDate() + 2);
    return (
      <>
        <style>{selctedDayStyle}</style>
        {this.props.monthsToDisplay > 1 &&
          <DayPicker localeUtils={MomentLocaleUtils} locale={this.state.local}
            initialMonth={this.props.fromMonth}
            className="Selectable"
            numberOfMonths={monthToDisplay}
            selectedDays={selected}
            modifiers={range}
            onDayClick={this.handleDayClick}
            disabledDays={disableDaysTimeFrame}
            fromMonth={new Date(SearchstartDate)}
            /* fromMonth={this.props.fromMonth} */
            toMonth={this.props.toMonth}
            navbarElement={this.state.isMobileDevice === 'sm' ? <NavbarMobile /> : <Navbar />}
            weekdayElement={<Weekday />}
            parseDate={this.parseDate}
            /* month = {new Date(SearchstartDate)} */
            defaultMonth = {range.from === undefined ? selected.form : range.from}
          />
        }

        {this.props.monthsToDisplay === 1 &&
          <DayPicker localeUtils={MomentLocaleUtils} 
            locale={this.state.local}
            initialMonth={this.props.fromMonth}
            className="Selectable"
            numberOfMonths={monthToDisplay}
            selectedDays={selected}
            modifiers={range}
            onDayClick={this.handleDayClick}
            disabledDays={disableDaysTimeFrame}
            fromMonth={new Date(SearchstartDate)}
            toMonth={this.props.toMonth}
            navbarElement={<Navbar />}
            weekdayElement={<Weekday />}
            month = {new Date(SearchstartDate)}
           
          />
        }
        <div className="calendar-ctas">
          <button className="btn btn-ghost text-primary mr-2" data-testid="clear_btn" data-messagecatalogdetails="MCDE_RCI_React_Favorites_Points_15" onClick={this.handleResetClick}>
            {getTranslatedMsg(15, this.state.msg_data, this.state.custlocale, 'RCI_React_Favorites_Points', 'Clear All')}
          </button>
          {this.props.monthsToDisplay > 1 && <button onClick={this.applyBtnClick} data-testid="Apply_btn" data-messagecatalogdetails="MCDE_RCI_React_Favorites_Points_16" className={`btn btn-primary ml-2 `} disabled={!checkInDate} >
            {getTranslatedMsg(16, this.state.msg_data, this.state.custlocale, 'RCI_React_Favorites_Points', 'Apply')}
          </button>}
          {this.props.monthsToDisplay == 1 && <button onClick={this.applyBtnClick} data-testid="Apply_btn" data-messagecatalogdetails="MCDE_RCI_React_Favorites_Points_16" className={`btn btn-primary ml-2`} disabled={!from} >
            {getTranslatedMsg(16, this.state.msg_data, this.state.custlocale, 'RCI_React_Favorites_Points', 'Apply')}
          </button>}
        </div>
      </>
    );
  }
}




const mapStateToProps = (state) => {
  return {
    msg_data: state.FavMsgCatReducer.msg_cat_data,
    custlocale: state.CommonReducer.locale,
    deselectChekInDate: state.TypeAheadReducer.clearCheckInDate,
    deselectChekOutDate: state.TypeAheadReducer.clearCheckOutDate,
    prevSelectedChekInDate: state.TypeAheadReducer.selectedCheckInDate,
    checkOutContainerClick:state.TypeAheadReducer.checkOutContainerClicked,
    checkInContainerClick:state.TypeAheadReducer.checkInContainerClicked
  }

}

export default connect(mapStateToProps)(RCIDatePicker);